import React from 'react';
import Button from '../button/button';
import './cta_gallery.css';

var _ref = React.createElement(
	'svg',
	{ xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16' },
	React.createElement('path', { id: 'Path_10', 'data-name': 'Path 10', d: 'M8,0,6.545,1.455l5.506,5.506H0V9.039H12.052L6.545,14.545,8,16l8-8Z', fill: '#e6e6e6' })
);

var CTAGallery = function CTAGallery(props) {
	var image = props.image,
	    cta = props.cta;

	return React.createElement(
		'section',
		{ className: 'cta-gallery wrapper' },
		React.createElement(
			'div',
			null,
			React.createElement(
				'div',
				{ className: 'cta' },
				React.createElement(
					'p',
					null,
					cta.text
				),
				React.createElement(Button, {
					url: cta.button_link,
					text: cta.button_text,
					icon: _ref
				})
			),
			React.createElement('img', { src: image.node.productImgMain })
		)
	);
};

export default CTAGallery;